import React from 'react'
import styled from 'styled-components'
import { useTable } from 'react-table'

import makeData from './makeData'
import {FormattedMessage} from "react-intl";

const Styles = styled.div`
  padding: 1rem;

  table {
    border-spacing: 0;
    border: 1px solid black;

    tr {
      :last-child {
        td {
          border-bottom: 0;
        }
      }
    }

    th,
    td {
      margin: 0;
      padding: 0.5rem;
      border-bottom: 1px solid black;
      border-right: 1px solid black;

      :last-child {
        border-right: 0;
      }
    }
  }
`

function Table({ columns, data ,deleteUser,username, selectItem}) {
  // Use the state and functions returned from useTable to build your UI
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = useTable({
    columns,
    data,
  })
  // Render the UI for your table
  return (
    <div className="tablewrapper" style={{height :'200px',width:'1320px',marginLeft:'-14px'}}>
      <table {...getTableProps()} >
      <thead>
      {headerGroups.map(headerGroup => (
        <tr {...headerGroup.getHeaderGroupProps()} >
          <th style={{textAlign:'center'}}>Select</th>
          {headerGroup.headers.map(column => (
            <th {...column.getHeaderProps()} style={{textAlign: 'center'}}>{column.render('Header')}</th>
          ))}
        </tr>
      ))}
      </thead>
      <tbody {...getTableBodyProps()}>
      {rows.map((row, i) => {
        prepareRow(row)
        // if(row.values.status != "DELETED" && row.values.username !== username){
        if(row.values.username !== username){
          return (
            <tr {...row.getRowProps()}>
              <td>
                <input type="radio" style={{width: '15px',marginLeft:'48%'}} name="radio1" style={{width: '15px', marginLeft:'41%'}} value={data[i]} onChange={()=>{selectItem(data[i]);}}
                />
              </td>
              {row.cells.map(cell => {
                if(cell.value !== "null"){
                  return <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                }else{
                  return <td {...cell.getCellProps()}></td>
                }
              })}
            </tr>
          )
        }
      })}
      </tbody>
    </table>
    </div>
  )
}

function App(props) {
  const columns = React.useMemo(
    () => [
      {
        Header: 'Name',
        accessor: 'name', // accessor is the "key" in the data
      },
     
      {
        Header: 'JDBC Driver',
        accessor: 'jdbcdriver', // accessor is the "key" in the data
      },

      {
        Header: 'Version',
        accessor: 'dbversion',
      },
      {
        Header: 'Host/Port',
        accessor: 'host', // accessor is the "key" in the data
      },

      {
        Header: 'DB Name',
        accessor: 'dbname', // accessor is the "key" in the data
      },
       {
          Header: 'User Name',
          accessor: 'dbusername', // accessor is the "key" in the data
        }
        // {
        //   Header: 'Password',
        //   accessor:'dbpassword',
        //   //accessor: 'updateBy', // accessor is the "key" in the data
        // }
       ],[]
  );

  // const data2 = React.useMemo(() => makeData(20), [])

  return (
    <Styles>
      <Table columns={columns} data={props.data} selectItem={props.selectItem} deleteUser={props.deleteUser} username={props.username}/>
    </Styles>
  )
}

export default App



// WEBPACK FOOTER //
// ./src/components/views/ManagementDDLjdbc2/table.js